import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import image1 from '../../assets/images/executive_pro.png';
import image2 from '../../assets/images/retro_round.png';

const CaretUpIcon = () => (
  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
  </svg>
);

const CaretDownIcon = () => (
  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const TruckIcon = () => (
  <svg className="w-5 h-5 text-[#2A3182]" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
  </svg>
);

const DeliveryIcon = () => (
  <svg className="w-5 h-5 text-[#2A3182]" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const PaymentIcon = () => (
  <svg className="w-5 h-5 text-[#2A3182]" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
  </svg>
);

const Checkout = () => {
  const [activeStep, setActiveStep] = useState(1);

  const orderItems = [
    {
      id: 1,
      badge: 'LUXE SERIES',
      title: 'Aura Nocturnal Blue',
      price: 'KSH. 185.00',
      image: image1,
    },
    {
      id: 2,
      badge: 'ACCESSORIES',
      title: 'Leather Artisan Case',
      price: 'KSH. 45.00',
      image: image2,
    },
  ];

  return (
    <div className="min-h-screen bg-white pb-10 pt-32 sm:pb-20 sm:pt-40">
      <div className="site-container">
        <div className="mb-8 text-center sm:mb-10 sm:text-left">
          <h1 className="mb-1 text-[28px] font-black leading-tight text-[#2A3182] sm:mb-2 sm:text-[36px]">Checkout</h1>
          <p className="text-[14px] font-medium text-gray-500 sm:text-[15px]">Please complete each step to finalize your order.</p>
        </div>

        <div className="flex flex-col gap-8 lg:flex-row lg:gap-12">
          <div className="flex flex-1 flex-col gap-4">
            <div className={`rounded-2xl border border-gray-100 bg-white sm:rounded-3xl ${activeStep === 1 ? 'shadow-[0_8px_30px_rgb(0,0,0,0.06)]' : 'shadow-sm'}`}>
              <div
                className="flex cursor-pointer items-center justify-between p-5 sm:p-6"
                onClick={() => setActiveStep(1)}
              >
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className={`flex h-8 w-8 items-center justify-center rounded-full text-[13px] font-bold ${activeStep === 1 ? 'bg-[#111827] text-white' : 'border border-gray-200 bg-white text-gray-400'}`}>
                    1
                  </div>
                  <div className="flex items-center gap-2 sm:gap-2.5">
                    <TruckIcon />
                    <h3 className="text-[15px] font-bold text-[#2A3182] sm:text-[16px]">Shipping Address</h3>
                  </div>
                </div>
                {activeStep === 1 ? <CaretUpIcon /> : <CaretDownIcon />}
              </div>

              {activeStep === 1 && (
                <div className="px-5 pb-6 sm:px-6 sm:pb-8">
                  <div className="border-t border-gray-100 pt-6">
                    <div className="mb-4 grid grid-cols-1 gap-4 sm:mb-6 sm:grid-cols-2 sm:gap-6">
                      <div>
                        <label className="mb-1.5 block text-[13px] font-medium text-[#2A3182]">First Name</label>
                        <input
                          type="text"
                          placeholder="Jane"
                          className="w-full rounded-xl border border-transparent bg-[#f3f4f6] px-4 py-3 text-[14px] text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:border-[#2A3182] focus:bg-white"
                        />
                      </div>
                      <div>
                        <label className="mb-1.5 block text-[13px] font-medium text-[#2A3182]">Last Name</label>
                        <input
                          type="text"
                          placeholder="Doe"
                          className="w-full rounded-xl border border-transparent bg-[#f3f4f6] px-4 py-3 text-[14px] text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:border-[#2A3182] focus:bg-white"
                        />
                      </div>
                    </div>

                    <div className="mb-4 sm:mb-6">
                      <label className="mb-1.5 block text-[13px] font-medium text-[#2A3182]">Address Line 1</label>
                      <input
                        type="text"
                        placeholder="123 Vision Avenue"
                        className="w-full rounded-xl border border-transparent bg-[#f3f4f6] px-4 py-3 text-[14px] text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:border-[#2A3182] focus:bg-white"
                      />
                    </div>

                    <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
                      <div>
                        <label className="mb-1.5 block text-[13px] font-medium text-[#2A3182]">City</label>
                        <input
                          type="text"
                          placeholder="London"
                          className="w-full rounded-xl border border-transparent bg-[#f3f4f6] px-4 py-3 text-[14px] text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:border-[#2A3182] focus:bg-white"
                        />
                      </div>
                      <div>
                        <label className="mb-1.5 block text-[13px] font-medium text-[#2A3182]">Postcode</label>
                        <input
                          type="text"
                          placeholder="EC1V 2NX"
                          className="w-full rounded-xl border border-transparent bg-[#f3f4f6] px-4 py-3 text-[14px] text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:border-[#2A3182] focus:bg-white"
                        />
                      </div>
                    </div>

                    <button
                      onClick={() => setActiveStep(2)}
                      className="rounded-full bg-[#111827] px-8 py-3.5 text-[14px] font-bold text-white transition-colors hover:bg-black"
                    >
                      Continue to Delivery
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className={`rounded-2xl border border-gray-100 bg-white sm:rounded-3xl ${activeStep === 2 ? 'shadow-[0_8px_30px_rgb(0,0,0,0.06)]' : 'shadow-sm'}`}>
              <div
                className="flex cursor-pointer items-center justify-between p-5 sm:p-6"
                onClick={() => setActiveStep(2)}
              >
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className={`flex h-8 w-8 items-center justify-center rounded-full text-[13px] font-bold ${activeStep === 2 ? 'bg-[#111827] text-white' : 'border border-gray-200 bg-white text-gray-400'}`}>
                    2
                  </div>
                  <div className="flex items-center gap-2 sm:gap-2.5">
                    <DeliveryIcon />
                    <h3 className="text-[15px] font-bold text-[#2A3182] sm:text-[16px]">Delivery Method</h3>
                  </div>
                </div>
                {activeStep === 2 ? <CaretUpIcon /> : <CaretDownIcon />}
              </div>
            </div>

            <div className={`rounded-2xl border border-gray-100 bg-white sm:rounded-3xl ${activeStep === 3 ? 'shadow-[0_8px_30px_rgb(0,0,0,0.06)]' : 'shadow-sm'}`}>
              <div
                className="flex cursor-pointer items-center justify-between p-5 sm:p-6"
                onClick={() => setActiveStep(3)}
              >
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className={`flex h-8 w-8 items-center justify-center rounded-full text-[13px] font-bold ${activeStep === 3 ? 'bg-[#111827] text-white' : 'border border-gray-200 bg-white text-gray-400'}`}>
                    3
                  </div>
                  <div className="flex items-center gap-2 sm:gap-2.5">
                    <PaymentIcon />
                    <h3 className="text-[15px] font-bold text-[#2A3182] sm:text-[16px]">Payment Information</h3>
                  </div>
                </div>
                {activeStep === 3 ? <CaretUpIcon /> : <CaretDownIcon />}
              </div>
            </div>
          </div>

          <div className="w-full flex-shrink-0 lg:w-[380px]">
            <div className="sticky top-28 rounded-2xl bg-white p-6 shadow-[0_8px_40px_-12px_rgba(0,0,0,0.1)] sm:rounded-[32px] sm:p-8">
              <h2 className="mb-6 text-[20px] font-bold text-[#2A3182] sm:mb-8 sm:text-[24px]">Order Summary</h2>

              <div className="mb-8 flex flex-col gap-5">
                {orderItems.map((item) => (
                  <div key={item.id} className="flex items-center gap-4">
                    <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-xl bg-gray-50 sm:h-20 sm:w-20">
                      <img src={item.image} alt={item.title} className="h-full w-full object-contain p-2 sm:p-3" />
                    </div>
                    <div className="flex-1">
                      <p className="mb-1 text-[10px] font-bold uppercase tracking-widest text-[#D83232]">
                        {item.badge}
                      </p>
                      <h4 className="mb-1 text-[14px] font-medium leading-tight text-[#2A3182] sm:text-[15px]">
                        {item.title}
                      </h4>
                      <p className="text-[14px] font-bold text-[#2A3182] sm:text-[15px]">
                        {item.price}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mb-6 space-y-4 border-t border-gray-100 pt-6">
                <div className="flex items-center justify-between text-[14px]">
                  <span className="font-medium text-gray-500">Subtotal</span>
                  <span className="font-medium text-[#2A3182]">KSH. 434.00</span>
                </div>
                <div className="flex items-center justify-between text-[14px]">
                  <span className="font-medium text-gray-500">Shipping</span>
                  <span className="font-medium text-gray-500">FREE</span>
                </div>
                <div className="flex items-center justify-between text-[14px]">
                  <span className="font-medium text-gray-500">Estimated Tax</span>
                  <span className="font-medium text-[#2A3182]">KSH. 34.72</span>
                </div>
              </div>

              <div className="mb-8 flex items-end justify-between border-t border-gray-100 pt-6">
                <span className="text-[20px] font-bold text-[#2A3182]">Total</span>
                <div className="flex items-center gap-1">
                  <span className="mb-0.5 text-[12px] font-bold uppercase tracking-tighter text-gray-900">KSH.</span>
                  <span className="text-[26px] font-black leading-none text-[#2A3182]">468.72</span>
                </div>
              </div>

              <Link to="/login" className="mb-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#c1272d] py-4 text-[15px] font-bold text-white shadow-lg shadow-red-500/30 transition-colors hover:bg-red-800">
                Place Order
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </Link>

              <p className="px-4 text-center text-[11px] leading-relaxed text-gray-500 sm:text-[12px]">
                By placing your order, you agree to our <a href="#terms" className="underline hover:text-gray-800">Terms of Service</a> and <a href="#privacy" className="underline hover:text-gray-800">Privacy Policy</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
